import { useEffect, useState, useRef } from "react";
import style from "./ReplaceForm.module.scss";

import { useFormik } from "formik";
import { object } from "yup";

import usePhoto from "../../hooks/usePhotos";
import DropzoneFile from "../DropzoneFile/DropzoneFile";
import { GalleryI, PhotoI } from "@/interfaces/galleries/Galleries";
import { IFile } from "../UploadImages/UploadImagesInterfaces";
import { notifySuccess, notifyError } from "@/utils/NotificationFunctions";
import CustomSpinner from "../CustomSpinner/CustomSpinner";
import toast from "react-hot-toast";

interface ReplaceFormI {
  gallery: GalleryI;
  replacePhoto: PhotoI | any;
  onHide: () => void;
}

const uploadSingleImage = object({});

const ReplaceForm = (props: ReplaceFormI) => {
  const { replacePhoto, onHide, gallery } = props;
  const { postPhotoReplace } = usePhoto();

  const [selectedFiles, setSelectedFiles] = useState<Array<any>>([]);
  const refImg = useRef<any>();
  const [imgNew, setNew] = useState<string>("");
  const [imgOld, setOld] = useState<string>("");
  // const [ formData, setFormData ] = useState<FormData | null>( null )
  const [isImgValid, setIsImgValid] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const getMeta = (url: string) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = url;
    });

  async function appendData(
    Objfile: IFile,
    galeria: GalleryI,
    dimenciones: string
  ): Promise<FormData> {
    const formData = new FormData();
    const numero = dimenciones.split("*");

    formData.append("file", Objfile.file);
    formData.append("name", Objfile.file.name);
    formData.append("collectionId", galeria._id);
    formData.append("photoId", replacePhoto._id);
    formData.append("collection", galeria.name);
    formData.append("imageWidth", numero[0].trim());
    formData.append("imageHeight", numero[1].trim());

    return formData;
  }
  const formik = useFormik({
    initialValues: {
      files: [],
      inputLink: "",
    },
    validationSchema: uploadSingleImage,
    onSubmit: async (values, { resetForm, setErrors }) => {
      setLoadingSubmit(true);
      if (replacePhoto.replacements && replacePhoto.replacements.length > 0) {
        setErrors({
          inputLink:
            "This unit has already been replaced before, by our rules it cannot be replaced twice. If it still looks not well, please text to Moderators, from your Profile page",
        });
        setLoadingSubmit(false);
        return;
      }
      if (values.files.length === 0 && values.inputLink === "") {
        setErrors({ inputLink: "the Image is required" });
        setLoadingSubmit(false);
        return;
      }
      try {
        if (values.files.length === 0 && values.inputLink !== "") {
          if (!isImgValid) {
            setErrors({ inputLink: "Isn't a valid link" });
            return;
          }
          const numero = imgNew.split("*");

          const data: any = {
            url: values.inputLink,
            collectionId: gallery._id,
            photoId: replacePhoto._id,
            collection: gallery.name,
            imageWidth: numero[0].trim(),
            imageHeight: numero[1].trim(),
          };

          await postPhotoReplace(data).then((res: any) => {
            if (res.status === 200) {
              notifySuccess(
                "Uploaded successfully. The content will be visible after the moderation."
              );
              onHide();
              resetForm();
              const { adminId } = res.data;
              adminId && window.location.reload();
            } else if (res.status === "error") {
              notifyError("The image cannot uploaded.");
            }
          });
        } else if (values.files.length > 0 && values.inputLink === "") {
          let file: IFile = values.files[0];

          const formData: FormData = await appendData(file, gallery, imgNew);

          await postPhotoReplace(formData).then((res: any) => {
            if (res.status === 200) {
              notifySuccess(
                "Uploaded successfully. The content will be visible after the moderation."
              );
              onHide();
              resetForm();
              const { adminId } = res.data;
              adminId && window.location.reload();
            } else if (res.status === "error") {
              notifyError("The image cannot uploaded.");
            }
          });
        }
      } catch (error) {
        console.error(error);
        notifyError("An error has occurred");
      } finally {
        setLoadingSubmit(false);
      }
    },
  });
  const { errors, touched } = formik;

  const handleInpuLink = (e: any) => {
    const { value } = e.target;
    formik.setFieldValue("inputLink", value);

    formik.setFieldValue("files", []);
    setSelectedFiles([]);

    setLoadingSubmit(true);

    if (value.trim() === "") {
      setIsImgValid(false);
      setLoadingSubmit(false);
      return;
    }

    try {
      const traerImg = async (url: string) => {
        try {
          const resp: any = await getMeta(url);

          if (resp.src !== undefined) {
            const realWidth: any = resp.naturalWidth;
            const realHeight: any = resp.naturalHeight;
            setNew(`${realWidth} * ${realHeight}`);

            setIsImgValid(resp.src !== undefined);
            setLoadingSubmit(resp.src === undefined);
          }

          const resp2: any = await getMeta(replacePhoto.url);

          if (resp2.src !== undefined) {
            const realWidth: any = resp2.naturalWidth;
            const realHeight: any = resp2.naturalHeight;
            setOld(`${realWidth} * ${realHeight}`);

            setIsImgValid(resp2.src !== undefined && resp.src !== undefined);
            setLoadingSubmit(resp2.src === undefined && resp.src === undefined);
          }
        } catch (err) {
          setIsImgValid(false);
          setLoadingSubmit(false);
          console.log(errors);
          formik.setErrors({ inputLink: "isn't a valid link" });
        }
      };
      traerImg(value);
    } catch (error) {
      console.log(error);
      setLoadingSubmit(false);
      formik.setErrors({ inputLink: "isn't a valid link" });
      setIsImgValid(false);
    }
  };

  useEffect(() => {
    const putOldImg = async () => {
      const { naturalHeight, naturalWidth }: any = await getMeta(
        replacePhoto.url
      );
      setOld(`${naturalWidth} * ${naturalHeight}`);
      setIsImgValid(!!selectedFiles[0]);
    };

    if (selectedFiles.length > 0) {
      putOldImg();
      formik.setFieldValue("inputLink", "");
    }
  }, [selectedFiles]);

  const handleImageLoad = () => {
    const newImg: any = refImg.current;
    const width = newImg.naturalWidth;
    const heigth = newImg.naturalHeight;

    setNew(`${width} * ${heigth}`);
  };
  return (
    <div className={style.ReplaceComponent}>
      <p className={style.row}>
        {" "}
        Replacement is only for the same picture but with better quality
      </p>

      {isImgValid && ( //!!selectedFiles.length || formik.values.inputLink !== ""
        <div className={`${style.colImg}  `}>
          <img
            ref={refImg}
            className={style.img}
            src={selectedFiles[0] || formik.values.inputLink}
            onLoad={handleImageLoad}
          />
          <p> New image: {imgNew} pixels </p>
          <p> Old image: {imgOld} pixels </p>
        </div>
      )}

      <div className={style.col}>
        <form onSubmit={formik.handleSubmit} className={style.ReplaceForm}>
          <div className="c-row">
            <DropzoneFile
              uploadType={"single"}
              selectedFiles={selectedFiles}
              formik={formik}
              setSelectedFiles={setSelectedFiles}
              fieldName="files"
            />
            {touched.files && errors.files && (
              <div className="form-error">{errors.files}</div>
            )}
          </div>
          <div className="d-flex flex-column">
            <label
              htmlFor="inputLink"
              className={`mb-2 ${style.labelInputlink}`}
            >
              Put the photo's URL here
            </label>
            <input
              name="inputLink"
              id="inputLink"
              type="text"
              value={formik.values.inputLink}
              onChange={handleInpuLink}
              autoComplete="off"
            />
          </div>
          {touched.inputLink && errors.inputLink && (
            <div className="form-error">{errors.inputLink}</div>
          )}
          <div className="c-row">
            <button
              type="submit"
              className={`btn linear-bg w-100 ${
                loadingSubmit ? "disabled" : ""
              }`}
            >
              {loadingSubmit ? (
                <CustomSpinner size={1.6} borderWidth={2} />
              ) : (
                "Go"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReplaceForm;
